import { render, staticRenderFns } from "./BusinessPlan.vue?vue&type=template&id=108eb5db&scoped=true"
import script from "./BusinessPlan.vue?vue&type=script&lang=ts"
export * from "./BusinessPlan.vue?vue&type=script&lang=ts"
import style0 from "./BusinessPlan.vue?vue&type=style&index=0&id=108eb5db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108eb5db",
  null
  
)

export default component.exports